import React, { useRef } from "react";
import { Dropdown, FormField, FormGroup, Input, Radio } from "semantic-ui-react";

export const BUSINESS_MODEL_OPTIONS = [
  { key: "INDIVIDUAL", value: "INDIVIDUAL", text: "บุคคลธรรมดา" },
  { key: "LEGAL_ENTITY", value: "LEGAL_ENTITY", text: "นิติบุคคล" },
];

const BusinessInformationForm = (props: any) => {
  return (
    <>
      <FormGroup inline>
        {!!props.width && (
          <FormField width={props.width} required>
            <label>รูปแบบธุรกิจ</label>
          </FormField>
        )}
        <FormField
          width={props.businessTypeWidth}
          inlin
          required
          error={
            (props.error?.business_type ||
              props.error?.branch_type ||
              (props.detail.business?.branch_type === "BRANCH" && props.error?.branch_name)) ??
            false
          }
        >
          {!props.width && <label>รูปแบบธุรกิจ</label>}

          <div style={{ display: "flex", alignItems: "center", gap: "20px", width: "100%" }}>
            <Dropdown
              disabled={props.readOnly}
              name="business.business_type"
              placeholder="-- กรุณาเลือกรูปแบบธุรกิจ --"
              value={props.detail.business?.business_type}
              selection
              options={BUSINESS_MODEL_OPTIONS}
              onChange={props.handleChangeValue}
              style={{ minWidth: "250px" }}
            />

            {props.detail.business?.business_type === "INDIVIDUAL" && (
              <div style={{ display: "flex", gap: "2rem", alignItems: "center" }}>
                <Radio
                  label="ไม่ระบุ"
                  name="business.branch_type"
                  value="NONE"
                  checked={
                    props.detail.business?.branch_type === "" ||
                    props.detail.business?.branch_type === null
                  }
                  onChange={() =>
                    props.handleChangeValue(null, {
                      name: "business.branch_type",
                      value: "",
                    })
                  }
                />
                <Radio
                  label="สำนักงานใหญ่"
                  name="business.branch_type"
                  value="HEADQUARTER"
                  checked={props.detail.business?.branch_type === "HEADQUARTER"}
                  onChange={props.handleChangeValue}
                />
                <Radio
                  label="สาขา"
                  name="business.branch_type"
                  value="BRANCH"
                  checked={props.detail.business?.branch_type === "BRANCH"}
                  onChange={props.handleChangeValue}
                />
              </div>
            )}

            {props.detail.business?.business_type === "LEGAL_ENTITY" && (
              <div style={{ display: "flex", gap: "2rem" }}>
                <div style={{ minWidth: "100px" }}>
                  <Radio
                    label="สำนักงานใหญ่"
                    name="business.branch_type"
                    value="HEADQUARTER"
                    checked={props.detail.business?.branch_type === "HEADQUARTER"}
                    onChange={props.handleChangeValue}
                  />
                </div>

                <Radio
                  label="สาขา"
                  name="business.branch_type"
                  value="BRANCH"
                  checked={props.detail.business?.branch_type === "BRANCH"}
                  onChange={props.handleChangeValue}
                />
              </div>
            )}
            {props.detail.business?.branch_type === "BRANCH" && (
              <FormField
                error={
                  props.detail.business?.branch_type === "BRANCH" && props.error?.branch_name
                    ? true
                    : false
                }
              >
                <Input
                  name="business.branch_name"
                  placeholder="ระบุรหัสสาขา หรือ ชื่อสาขา"
                  value={props.detail.business?.branch_name}
                  onChange={props.handleChangeValue}
                  disabled={props.readOnly}
                  style={{ minWidth: "200px" }}
                />
              </FormField>
            )}
          </div>
        </FormField>
      </FormGroup>

      {(props.detail.business?.business_type === "INDIVIDUAL" ||
        props.detail.business?.business_type === "LEGAL_ENTITY") && (
        <FormGroup inline>
          {!!props.width && (
            <FormField width={props.width} required>
              <label>
                {props.detail.business?.business_type === "INDIVIDUAL"
                  ? "ชื่อ-นามสกุล"
                  : "ชื่อธุรกิจ"}
              </label>
            </FormField>
          )}
          <FormField
            width={props.width ? 8 : 11}
            inline
            required
            error={
              props.detail.business?.business_type === "INDIVIDUAL"
                ? (props.error?.first_name || props.error?.last_name) ?? false
                : props.detail.business?.business_type === "LEGAL_ENTITY"
                ? props.error?.business_name ?? false
                : false
            }
            style={{ display: "flex", alignItems: "center" }}
          >
            {!props.width && (
              <label>
                {props.detail.business?.business_type === "INDIVIDUAL"
                  ? "ชื่อ-นามสกุล"
                  : "ชื่อธุรกิจ"}
              </label>
            )}

            {props.detail.business?.business_type === "INDIVIDUAL" && (
              <>
                <Input
                  name="business.first_name"
                  placeholder="กรุณาระบุชื่อ"
                  value={props.detail.business?.first_name}
                  onChange={props.handleChangeValue}
                  disabled={props.readOnly}
                  style={{ flex: 1, marginRight: "20px" }}
                />
                <Input
                  name="business.last_name"
                  placeholder="กรุณาระบุนามสกุล"
                  value={props.detail.business?.last_name}
                  onChange={props.handleChangeValue}
                  disabled={props.readOnly}
                  style={{ flex: 1 }}
                />
              </>
            )}

            {props.detail.business?.business_type === "LEGAL_ENTITY" && (
              <Input
                name="business.business_name"
                placeholder="ชื่อธุรกิจ"
                value={props.detail.business?.business_name}
                onChange={props.handleChangeValue}
                disabled={props.readOnly}
                style={{ flex: 1 }}
              />
            )}
          </FormField>
        </FormGroup>
      )}

      <FormGroup inline>
        {!!props.width && (
          <FormField width={props.width} required>
            <label>เลขประจำตัวผู้เสียภาษี</label>
          </FormField>
        )}
        <FormField width={11} inline required error={props.error?.tax_payer_id ?? false}>
          {!props.width && <label>เลขประจำตัวผู้เสียภาษี</label>}
          <div style={{ display: "flex" }}>
            {Array.from({ length: 13 }).map((_, index) => {
              const extraMargin = [0, 4, 9].includes(index) ? 15 : 0;
              const rawTax = props.detail.business?.tax_payer_id || "";
              const taxIdArray = rawTax.padEnd(13, " ").split("");
              return (
                <Input
                  key={index}
                  name="business.tax_payer_id"
                  id={`Business-TaxID-${index}`}
                  value={taxIdArray[index] === " " ? "" : taxIdArray[index]}
                  disabled={props.readOnly}
                  style={{
                    width: "40px",
                    textAlign: "center",
                    marginRight: extraMargin,
                  }}
                  input={{ type: "text", maxLength: 1 }}
                  onChange={(e) => {
                    const digit = e.target.value.replace(/\D/g, "").slice(0, 1);
                    let arr = (props.detail.business?.tax_payer_id || "").padEnd(13, " ").split("");
                    arr[index] = digit || " ";

                    props.handleChangeValue(e, {
                      name: "business.tax_payer_id",
                      value: arr.join(""),
                    });

                    if (digit && index < 12) {
                      document.getElementById(`Business-TaxID-${index + 1}`)?.focus();
                    }
                  }}
                  onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                    if (e.key === "Backspace") {
                      const arr = (props.detail.business?.tax_payer_id || "")
                        .padEnd(13, " ")
                        .split("");
                      const current = arr[index];

                      if ((current === " " || current === "") && index > 0) {
                        const prevInput = document.getElementById(
                          `Business-TaxID-${index - 1}`
                        ) as HTMLInputElement | null;
                        prevInput?.focus();
                        e.preventDefault();
                      }
                    }
                  }}
                />
              );
            })}
          </div>
        </FormField>
      </FormGroup>
    </>
  );
};

export default BusinessInformationForm;
